<template>
  <div class="box">
    <div class="boxa">
      班次名称:
      <Input
        @on-change="getname1(value1)"
        v-model="value1"
        placeholder="请输入班次名称"
        style="width: 200px"
      />
    </div>
    <div class="boxb">
      默认班次:
      <el-switch v-model="value2" :active-value="1" :inactive-value="2">
      </el-switch>
    </div>
    <div class="boxb">
      是否上班:
      <el-switch v-model="value3" :active-value="true" :inactive-value="false">
      </el-switch>
    </div>
    <!-- <div class="boxc">
      <span>上班日:</span>
      <div class="boxc2">
        <CheckboxGroup v-model="week1" @on-change="getweek(week1)">
          <Checkbox label="周一"></Checkbox>
          <Checkbox label="周二"></Checkbox>
          <Checkbox label="周三"></Checkbox>
          <Checkbox label="周四"></Checkbox>
          <Checkbox label="周五"></Checkbox>
          <Checkbox label="周六"></Checkbox>
          <Checkbox label="周日"></Checkbox>
        </CheckboxGroup>
      </div>
    </div> -->
    <div class="boxc" v-if="value3">
      <span>上班时间:</span>
      <div class="boxc3">
        <TimePicker
          v-model="startTime"
          format="HH:mm"
          placeholder="选择时间"
          style="width: 112px"
          @on-change="gettime1"
        />
      </div>
    </div>
    <div class="boxc" v-if="value3">
      <span>下班时间:</span>
      <div class="boxc3">
        <TimePicker
          v-model="endTime"
          format="HH:mm"
          placeholder="选择时间"
          style="width: 112px"
          @on-change="gettime2"
        />
      </div>
    </div>
    <div class="boxd" style="display: flex; align-items: center">
      请选择颜色：<el-color-picker v-model="colorStr"></el-color-picker>
    </div>
    <!-- <div class="boxd">
      绑定工程师:
      <Select
        multiple
        v-model="model"
        style="width: 400px"
        label-in-value
        @on-change="xuanengineer"
      >
        <Option v-for="item in engineerList" :value="item.value" :key="item.value">{{
          item.label
        }}</Option>
      </Select>
    </div> -->
    <div style="display: flex; justify-content: center; margin: 40px 0">
      <Button type="primary" style="margin: 0 20px 0 0" @click="onAdd()">
        确认
      </Button>
      <Button type=" primary" @click="$emit('onCancel')"> 取消 </Button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      value1: "",
      value2: "",
      value3: true,
      colorStr: "",
      week1: [],
      week3: "",
      startTime: "",
      endTime: "",
      model: [],
      engineerList: [],
      selectedTimes: [],
      engineerNameList: [],
    };
  },
  props: ["onCancel", "Id"],
  mounted() {
    if (this.Id) {
      this.getinfo(this.Id);
    }
  },
  created() {
    this.getengineer();
  },
  methods: {
    xuanengineer(val) {
      if (val != []) {
        this.engineerNameList = val.map((item) => {
          return item.value;
        });
      }
    },
    getinfo(id) {
      $utils.api.load(`/admin/system/classes/detail/${id}`).then((res) => {
        if (res && res.data) {
          console.log(res);
          let info = res.data;
          this.value1 = info.name;
          this.value2 = info.isDefault;
          this.startTime = info.workStartTime;
          if (info.workEndTime == "00:00" && info.workStartTime == "00:00") {
            this.value3 = false;
          }
          this.endTime = info.workEndTime;
          this.colorStr = info.color;
          this.selectedTimes = [info.workStartTime, info.workEndTime];
        }
      });
    },
    getengineer() {
      let q = {};
      $utils.api
        .load(`/admin/system/maiUser/maiUserByClasses`, q)
        .then((res) => {
          if (res && res.data) {
            let arr = res.data;
            this.engineerList = arr.map((item) => {
              return { value: item.userId, label: item.nickName };
            });
          }
        });
    },
    //提交
    onAdd() {
      let q = {};
      q.id = this.Id;
      q.name = this.value1;
      q.numbers = this.model.length;
      q.type = 1;
      q.isDefault = this.value2;
      q.workday = this.week3;
      q.workStartTime = this.startTime;
      q.workEndTime = this.endTime;
      q.delStatus = 1;
      q.engineerId = this.engineerNameList;
      if (!this.colorStr) {
        $utils.toast.success("请选择颜色！");
        return;
      }
      q.color = this.colorStr;
      if (!this.value3) {
        q.workStartTime = "00:00";
        q.workEndTime = "00:00";
      }
      if (
        this.value3 &&
        q.workStartTime == "00:00" &&
        q.workEndTime == "00:00"
      ) {
        $utils.toast.success("请重新选择上班时间和下班时间！");
        return;
      }
      $utils.api.load(`/admin/system/classes`, q, "put").then((res) => {
        if (res.code == 200) {
          $utils.toast.success("编辑成功");
          this.$emit("onCancel"); //保存后关闭弹窗
        }
      });
    },
    convertToChineseWeek(inputString) {
      var dayMap = {
        1: "周日",
        2: "周一",
        3: "周二",
        4: "周三",
        5: "周四",
        6: "周五",
        7: "周六",
      };
      var result = inputString.split(",").map(function (num) {
        return dayMap[num.replace(/'/g, "")];
      });
      return result;
    },
    getweek(val) {
      var dayMap = {
        周日: "1",
        周一: "2",
        周二: "3",
        周三: "4",
        周四: "5",
        周五: "6",
        周六: "7",
      };
      this.week3 = val
        .map(function (day) {
          return dayMap[day];
        })
        .join(",");
    },
    gettime1(val) {
      this.startTime = val;
    },
    gettime2(val) {
      this.endTime = val;
    },
  },
};
</script>

<style>
.box {
}

.boxc2 {
  display: inline-block;
  margin-left: 15px;
}

.boxc3 {
  display: inline-block;
  margin-left: 5px;
}

.boxa,
.boxb,
.boxc,
.boxd {
  margin: 10px 0;
}
</style>
